import apiClient from './client';

export const securitySettingsAPI = {
  getSettings: async () => {
    const response = await apiClient.get('/settings/security');
    return response.data;
  },

  updateSettings: async (settings) => {
    const response = await apiClient.put('/settings/security', settings);
    return response.data;
  }
};
